import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import FilterHome from "../../../../components/commonComponents/filterHome/FilterHome";
import { ICONS } from "../../../../assets/icons";
import {
  broadcastPerformanceFilter,
  HomeFilterCampaign,
} from "../../../../constant/app/Filter/Filter";
import { getBroadcastPerformanceCount } from "../../api/index";
import { useAspSelector } from "test/jest-redux-hooks";
import { useLocation, useNavigate, useParams } from "react-router-dom";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const BroadcastPerformance = () => {
  const { currentBrand } = useAspSelector((state) => state?.app);
  const { id } = useParams();
  const campaignId = id;

  const navigate = useNavigate();
  const location = useLocation();
  const campaignOverviewData = location?.state?.data;

  const [broadcastCount, setBroadcastCount] = useState(3);
  const [broadcastPerformanceList, setBroadcastPerformanceList] = useState([]);

    const generateDummyData = (count) => {
    const dummyData = [];
    const statuses = ['Draft', 'Scheduled', 'Sent', 'Completed'];
    
    for (let i = 0; i < count; i++) {
      const sent = Math.floor(Math.random() * 1000) + 100;
      const delivered = Math.floor(sent * (0.8 + Math.random() * 0.15)); // 80-95% of sent
      const opened = Math.floor(delivered * (0.4 + Math.random() * 0.3)); // 40-70% of delivered
      const bounced = Math.floor(sent * (0.01 + Math.random() * 0.04)); // 1-5% of sent
      
      dummyData.push({
        broadcast_name: `Test Broadcast ${i + 1}`,
        sent_count: sent,
        delivered_count: delivered,
        opened_count: opened,
        bounced_count: bounced
      });
    }
    
    return dummyData;
  };

  const BroadcastPerformnList = (brandId) => {
    if (currentBrand?.brand_mode === 'test') {
      // Use dummy data in test mode
      const dummyData = generateDummyData(broadcastCount);
      setBroadcastPerformanceList(dummyData);
    } else if (campaignId && brandId) {
      getBroadcastPerformanceCount(campaignId, brandId, broadcastCount).then(
        (res) => {
          if (res?.data?.length > 0) {
            setBroadcastPerformanceList(res?.data);
          }
        }
      );
    }
  };

  useEffect(() => {
    if (location?.pathname === `/user/campaign/view/${campaignId}/overview`) {
      BroadcastPerformnList(currentBrand?.brand_id, campaignId, broadcastCount);
    }
  }, [currentBrand, campaignId, broadcastCount, location]);

  const handleFilterChange = (filter) => {
    let recent_broadcast_count;

    switch (filter) {
      case "Last 3 Broadcasts":
        recent_broadcast_count = 3;
        break;
      case "Last 5 Broadcasts":
        recent_broadcast_count = 5;
        break;
      case "Last 7 Broadcasts":
        recent_broadcast_count = 7;
        break;
      case "Last 10 Broadcasts":
        recent_broadcast_count = 10;
        break;

      default:
        recent_broadcast_count = 3;
    }

    setBroadcastCount(recent_broadcast_count);
  };

  // const labels = broadcastPerformanceList?.map(
  //   (item) => `${item?.broadcast_name}`
  // );

  const labels = broadcastPerformanceList?.map((item) => {
    const name = item?.broadcast_name || "";
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  });

  // const labels = salesData.map((item, index) => (
  //   <div key={index} style={{ color: item.label_bg }}>
  //     {item.name}
  //   </div>
  // ));

  const totalCount = broadcastPerformanceList?.map(
    (item) => item?.total_count || 0
  ) || [];


  const sentCount = broadcastPerformanceList?.map(
    (item) => item?.sent_count || 0
  );

  const deliveredCount =
    broadcastPerformanceList?.map((item) => item?.delivered_count || 0) || []; // Default to empty array if undefined

  const openedCount =
    broadcastPerformanceList?.map((item) => item?.opened_count || 0) || [];

  const bouncedCount =
    broadcastPerformanceList?.map((item) => item?.bounced_count || 0) || [];

  // const yAxisMax = Math.ceil((maxCombinedValue * 1.1) / 100) * 100;

  const paddedDeliveredCount =
    deliveredCount?.length < 4
      ? [...deliveredCount, ...new Array(4 - deliveredCount?.length).fill(0)]
      : deliveredCount;

  const data = {
    labels: labels,
    datasets: [
      {
        label: "Total",
        data:
          totalCount.length < 4
            ? [...totalCount, ...new Array(4 - totalCount.length).fill(0)]
            : totalCount,
        fill: false,
        backgroundColor: totalCount.map((value) =>
          value === 0 ? "#A175FF" : "#A175FF"
        ),
        borderWidth: 1,
        borderRadius: 4,
      },
      {
        label: "Sent",
        data:
          sentCount.length < 4
            ? [...sentCount, ...new Array(4 - sentCount.length).fill(0)]
            : sentCount,
        fill: false,
        backgroundColor: sentCount.map((value) =>
          value === 0 ? "#0ACD95" : "#0ACD95"
        ),
        borderWidth: 1,
        borderRadius: 4,
      },
      {
        label: "Delivered",
        data: paddedDeliveredCount,
        fill: false,
        backgroundColor: paddedDeliveredCount?.map((value) =>
          value === 0 ? "#F6A723" : "#F6A723"
        ),
        borderWidth: 1,
        borderRadius: 4,
      },
      {
        label: "Opened",
        data:
          openedCount.length < 4
            ? [...openedCount, ...new Array(4 - openedCount.length).fill(0)]
            : openedCount,
        fill: false,
        backgroundColor: openedCount.map((value) =>
          value === 0 ? "#007AFF" : "#007AFF"
        ),
        borderWidth: 1,
        borderRadius: 4,
      },
      {
        label: "Bounced",
        data:
          bouncedCount.length < 4
            ? [...bouncedCount, ...new Array(4 - bouncedCount.length).fill(0)]
            : bouncedCount,
        fill: false,
        backgroundColor: bouncedCount.map((value) =>
          value === 0 ? "#FF543E" : "#FF543E"
        ),
        borderWidth: 1,
        borderRadius: 4,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,

    plugins: {
      legend: {
        position: "bottom",
        pointRadius: 6,
        layout: {
          padding: {
            top: 70,
            bottom: 10,
          },
        },
        labels: {
          type: "category",
          usePointStyle: true,
          pointStyle: "circle",
          padding: 30,
          pointRadius: 10,
        },
      },
      tooltip: {
        mode: "index",
        intersect: false,
        padding: 10,
        callbacks: {
          label: function (tooltipItem) {
            const value = tooltipItem.raw; // Get the value of the current item
            if (value === 0) {
              return null; // Hide this item from the tooltip
            }
            // Customize the label as needed
            return `${tooltipItem.dataset.label}: ${value}`;
          },
        },
      },
    },

    barPercentage: 0.9,
    categoryPercentage: 0.13,
    scales: {
      x: {
        grid: {
          color: "#E8E8EA", // Change the X-axis grid line color
          borderColor: "#E8E8EA", // Change the X-axis line color
        },
        ticks: {
          font: {
            size: 16,
            weight: "500",
            color: "var(--font-600)",
          },
          callback: function (value, index, ticks) {
            let label = this.chart.data.labels[index]; // Get the label
            return label.length > 10 ? label.substring(0, 10) + "..." : label; // Truncate if longer than 10 characters
          },

          render: function (value, index, ticks) {
            const labels = this.chart.data.labels;
          },
          padding: 1,
        },
      },
      y: {
        beginAtZero: true,
        // max: yAxisMax,
        grid: {
          color: "#E8E8EA", // Change the X-axis grid line color
          borderColor: "#E8E8EA", // Change the X-axis line color
        },

        ticks: {
          stepSize: 2,
          font: {
            size: 16,
            weight: "500",
            color: "var(--font-600)",
          },

          callback: function (value) {
            if (value >= 1000) {
              return `${value / 1000}k`;
            }
            return value;
          },
          maxTicksLimit: 10,
        },
      },
    },
  };

  return (
    <div className="bg-white rounded-[1vw] px-[2vw] py-[1vw] w-100">
      <div className="flex-row justify-between items-center pb-4">
        <p className="flex-row items-center chart-headers">
          Broadcast Performance
          <div
            className="ml-2 pointer"
            onClick={() => {
              navigate(`/user/campaign/view/${id}/execution`, {
                state: { data: campaignOverviewData },
              });
            }}
          >
            <img src={ICONS?.homeDownload} className="w-[18px] h-[18px]" />
          </div>
        </p>

        {broadcastPerformanceList?.length > 0 && (
          <FilterHome
            filterList={broadcastPerformanceFilter}
            fetchApiByFilter={handleFilterChange}
          />
        )}
      </div>

      <div style={{ height: "36vh", padding: "1vw 1vw" }}>
        {broadcastPerformanceList?.length > 0 ? (
          <Bar data={data} options={options} />
        ) : (
          <div className="h-full flex flex-col items-center justify-center">
            <img src={ICONS?.noChartData} alt="noChartData" />
            <p className="text-[#616874]">There’s no data yet</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default BroadcastPerformance;
